import {
  SellarDistributionContactCreateRequestType,
  SellarDistributionContactCreateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useSellarDistributionContactCreate = (options?: {
  retailerId?: number;
}) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: SellarDistributionContactCreateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `sellar-distribution-contact`,
        data,
        ...(options?.retailerId && {
          headers: { RetailerId: options.retailerId.toString() },
        }),
      }).then(
        (data) =>
          apiV2AssertResponse(data)
            .data as SellarDistributionContactCreateResponseType,
      ),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.SellarDistributionContact],
      });
    },
  });
};
